import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';

@Injectable({
    providedIn: 'root',
})
export class FaqDetailsService {
    constructor(private _apiService: ApiService) {}

    getFaqDetails(cat: string): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.FAQ).pipe(
            map((data: any) => {
                const catData = data.filter((item: any) => {
                    return (
                        item.categoryEn
                            .replaceAll(' ', '-')
                            .replaceAll('?', '')
                            .toLowerCase() === cat ||
                        item.categoryBm
                            .replaceAll(' ', '-')
                            .replaceAll('?', '')
                            .toLowerCase() === cat
                    );
                })[0];

                return catData;
            })
        );
    }
}
